// extracted by mini-css-extract-plugin
export default {"accountLabelGroup":"UiTVFrIlwxSxW2gXaGZi","label":"GnokzduuN1QpYEJUBM22"};